import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, MapPin, Phone } from "lucide-react";
import { CHURCH } from "../lib/data";

const quick = [
  ["Home", "/"], ["About", "/about"], ["Leadership", "/leadership"],
  ["Ministries", "/ministries"], ["Events", "/events"], ["Sermons", "/sermons"],
  ["Give", "/give"], ["Contact", "/contact"], ["Prayer Request", "/contact#prayer"],
  ["Plan Your Visit", "/plan-your-visit"],
];

export const Footer = () => (
  <footer className="relative bg-[#0A0A0A] text-white grain overflow-hidden" data-testid="footer">
    <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 pt-24 pb-10">
      <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12 mb-20">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <img src={CHURCH.logo} alt="One Love Ministries" className="w-12 h-12 object-contain bg-white rounded-full p-1" />
            <span className="font-display font-extrabold tracking-tight">ONE LOVE MINISTRIES</span>
          </div>
          <p className="text-white/60 leading-relaxed max-w-sm mb-6">
            One Church. One Family. One Love. A place where faith grows, lives are transformed, and everyone is welcomed with love.
          </p>
          <div className="flex gap-3">
            {[["facebook", Facebook], ["instagram", Instagram], ["youtube", Youtube]]
              .filter(([k]) => CHURCH.social[k])
              .map(([k, Icon]) => (
                <a key={k} href={CHURCH.social[k]} target="_blank" rel="noopener noreferrer" aria-label={k} data-testid={`social-${k}`} className="grid place-items-center w-11 h-11 rounded-full border border-white/15 hover:bg-[#E63946] hover:border-[#E63946] transition-colors"><Icon size={18} /></a>
              ))}
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.22em] text-white/40 mb-5">Quick Links</h4>
          <ul className="grid grid-cols-2 gap-y-2.5 gap-x-4">
            {quick.map(([l, to]) => (
              <li key={l}><Link to={to} className="text-white/70 hover:text-[#E63946] transition-colors text-sm">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.22em] text-white/40 mb-5">Visit Us</h4>
          <a href={CHURCH.directions} target="_blank" rel="noopener noreferrer" className="flex gap-3 text-white/70 hover:text-[#E63946] transition-colors mb-4">
            <MapPin size={18} className="mt-0.5 shrink-0" />
            <span className="text-sm">{CHURCH.address}<br />{CHURCH.cityStateZip}</span>
          </a>
          <a href={CHURCH.phoneHref} className="flex gap-3 text-white/70 hover:text-[#E63946] transition-colors">
            <Phone size={18} className="shrink-0" /><span className="text-sm">{CHURCH.phone}</span>
          </a>
        </div>
      </div>

      <div className="font-display font-extrabold tracking-tight leading-[0.85] text-[16vw] md:text-[13vw] text-white/[0.06] select-none pointer-events-none -mb-4">
        ONE LOVE
      </div>

      <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between gap-4 text-white/40 text-xs">
        <span>© {new Date().getFullYear()} One Love Ministries. All Rights Reserved.</span>
        <span>8501 Colonel Glenn Rd. · Little Rock, AR 72204 · {CHURCH.phone}</span>
      </div>
    </div>
  </footer>
);
